exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-area[data-v-0fdd73f9]{padding:20px 0px 0px 20px}\n", ""]);

// exports
